module.exports = __webpack_public_path__ + "img/KSC07756.d132fc31.jpg";